var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevel10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 94c25.957 0 47-21.043 47-47S72.957 0 47 0 0 21.043 0 47s21.043 47 47 47Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m29.9 61.1-7.1 19.4c-.5 1.4 1 2.7 2.3 2.1l4.3-2.1c.9-.4 1.9 0 2.3.8l1.9 4.4c.6 1.4 2.6 1.3 3.1-.1l7.1-19.4",
    fill: "#FF6F6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m29.9 61.1-7.1 19.4c-.5 1.4 1 2.7 2.3 2.1l4.3-2.1c.9-.4 1.9 0 2.3.8l1.9 4.4c.6 1.4 2.6 1.3 3.1-.1l7.1-19.4",
    stroke: "#E05F5F",
    strokeWidth: 3.356,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m64.7 61.1 7.1 19.4c.5 1.4-1 2.7-2.3 2.1l-4.3-2.1c-.9-.4-1.9 0-2.3.8L61 85.7c-.6 1.4-2.6 1.3-3.1-.1l-7.1-19.4",
    fill: "#FF6F6C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m64.7 61.1 7.1 19.4c.5 1.4-1 2.7-2.3 2.1l-4.3-2.1c-.9-.4-1.9 0-2.3.8L61 85.7c-.6 1.4-2.6 1.3-3.1-.1l-7.1-19.4",
    stroke: "#E05F5F",
    strokeWidth: 3.356,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m78.7 37.7 1.5-2.6c1.4-2.4.6-5.5-1.9-6.9l-2.6-1.5c-1.6-.9-2.5-2.6-2.5-4.4v-3c0-2.8-2.3-5.1-5.1-5.1h-3c-1.8 0-3.5-1-4.4-2.5l-1.5-2.6c-1.4-2.4-4.5-3.3-6.9-1.9l-2.6 1.5c-1.6.9-3.5.9-5.1 0L42 7.2c-2.4-1.4-5.5-.6-6.9 1.9l-1.5 2.6c-.9 1.6-2.6 2.5-4.4 2.5h-3c-2.8 0-5.1 2.3-5.1 5.1v3c0 1.8-1 3.5-2.5 4.4L16 28.2c-2.4 1.4-3.3 4.5-1.9 6.9l1.5 2.6c.9 1.6.9 3.5 0 5.1l-1.5 2.6c-1.4 2.4-.6 5.5 1.9 6.9l2.6 1.5c1.6.9 2.5 2.6 2.5 4.4v3c0 2.8 2.3 5.1 5.1 5.1h3c1.8 0 3.5 1 4.4 2.5l1.5 2.6c1.4 2.4 4.5 3.3 6.9 1.9l2.6-1.5c1.6-.9 3.5-.9 5.1 0l2.6 1.5c2.4 1.4 5.5.6 6.9-1.9l1.5-2.6c.9-1.6 2.6-2.5 4.4-2.5h3c2.8 0 5.1-2.3 5.1-5.1v-3c0-1.8 1-3.5 2.5-4.4l2.6-1.5c2.4-1.4 3.3-4.5 1.9-6.9l-1.5-2.6c-.9-1.6-.9-3.5 0-5.1Z",
    fill: "#FF6F6C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m78.7 37.7 1.5-2.6c1.4-2.4.6-5.5-1.9-6.9l-2.6-1.5c-1.6-.9-2.5-2.6-2.5-4.4v-3c0-2.8-2.3-5.1-5.1-5.1h-3c-1.8 0-3.5-1-4.4-2.5l-1.5-2.6c-1.4-2.4-4.5-3.3-6.9-1.9l-2.6 1.5c-1.6.9-3.5.9-5.1 0L42 7.2c-2.4-1.4-5.5-.6-6.9 1.9l-1.5 2.6c-.9 1.6-2.6 2.5-4.4 2.5h-3c-2.8 0-5.1 2.3-5.1 5.1v3c0 1.8-1 3.5-2.5 4.4L16 28.2c-2.4 1.4-3.3 4.5-1.9 6.9l1.5 2.6c.9 1.6.9 3.5 0 5.1l-1.5 2.6c-1.4 2.4-.6 5.5 1.9 6.9l2.6 1.5c1.6.9 2.5 2.6 2.5 4.4v3c0 2.8 2.3 5.1 5.1 5.1h3c1.8 0 3.5 1 4.4 2.5l1.5 2.6c1.4 2.4 4.5 3.3 6.9 1.9l2.6-1.5c1.6-.9 3.5-.9 5.1 0l2.6 1.5c2.4 1.4 5.5.6 6.9-1.9l1.5-2.6c.9-1.6 2.6-2.5 4.4-2.5h3c2.8 0 5.1-2.3 5.1-5.1v-3c0-1.8 1-3.5 2.5-4.4l2.6-1.5c2.4-1.4 3.3-4.5 1.9-6.9l-1.5-2.6c-.9-1.6-.9-3.5 0-5.1Z",
    stroke: "#E05F5F",
    strokeWidth: 3.43,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3 66.9c14.801 0 26.8-11.999 26.8-26.8S62.101 13.3 47.3 13.3 20.5 25.299 20.5 40.1s11.999 26.8 26.8 26.8Z",
    fill: "#E05F5F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m49 22.5 4.2 8.5c.3.5.8.9 1.4 1l9.3 1.4c1.5.2 2.1 2.1 1 3.1L58.1 43c-.4.4-.6 1-.5 1.6l1.6 9.3c.3 1.5-1.3 2.6-2.7 1.9l-8.4-4.4c-.5-.3-1.2-.3-1.7 0L38 55.8c-1.3.7-2.9-.4-2.7-1.9l1.6-9.3c.1-.6-.1-1.2-.5-1.6l-6.8-6.6c-1.1-1.1-.5-2.9 1-3.1l9.3-1.4c.6-.1 1.1-.5 1.4-1l4.2-8.5c.9-1.3 2.8-1.3 3.5.1Z",
    fill: "#FFD41F",
    stroke: "#F4C500",
    strokeWidth: 2.014
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel10);
export default __webpack_public_path__ + "static/media/level10.090d53ba.svg";
export { ForwardRef as ReactComponent };